import { createFileRoute } from "@tanstack/react-router";
import { zodValidator } from "@tanstack/zod-adapter";
import { DefiPoolDetailPage } from "../../features/defi/pages/defi-pool-detail-page";
import { poolDetailSearchSchema } from "../../shared/utils/search-params-schema";

export const Route = createFileRoute("/_layout/defi/pool/$tokenAddress/$protocolId")({
  component: DefiPoolDetailPage,
  validateSearch: zodValidator(poolDetailSearchSchema),
});
